export const api = {
  v1: {
    blocks: 'api/v1/blocks',
    events: 'api/v1/events',
    reports: 'api/v1/reports',
    lookups: 'api/v1/lookups',
    strategicAreas: 'api/v1/strategic-areas',
    import: 'api/v1/import',
    export: 'api/v1/export'
  }
};
